module.exports = __webpack_public_path__ + "img/solution-2.1a744431.jpg";